<template>
    <div id="PowerScan" class='row justify-content-center'>
        <div class='titie col-12'>
            <h1>
            PowerScan
            <span><!-- Insert yellow lightning icon here --></span>
            </h1>
        </div>
        <div class='PsFrontpage pt-4 col-12'>
            <div class='PsFrontpageButton justify-content-center row'>
            <div class="ButtonWrapper pb-4 col-12">
            <button class="btn btn-secondary BinTransfer w-100" @click="$router.push('/power-scan/xfer-to-bin-location')">
                <!--<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-left-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"/>
                </svg>-->
                <span><ItemTransfersIcon/></span>
                Xfer Items to Bin/Location
            </button>
            </div>
            </div>
            <!-- <div class='PsFrontpageButton justify-content-center row'>
            <div class="ButtonWrapper pb-4 col-12">
            <button class="btn btn-secondary SiteTransfer w-100" @click="$router.push('/power-scan/xfer-to-site')">
                <span><ItemTransfersIcon/></span> -->
                <!--<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-left-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"/>
                </svg>-->
               <!-- Xfer Items to a Site
            </button>
            </div>
            </div> -->
            <div class='PsFrontpageButton justify-content-center row'>
            <div class="ButtonWrapper pb-4 col-12">
            <button class="btn btn-secondary Picklists w-100" @click="$router.push('/power-scan/pick-lists')">
                <span><PickListsIcon/></span>
                <!--<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-card-checklist" viewBox="0 0 16 16">
                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>
                </svg>-->
                Pick Lists
            </button>
            </div>
            </div>
            <div class='PsFrontpageButton justify-content-center row'>
            <div class="ButtonWrapper pb-4 col-12">
            <button class="btn btn-secondary BinMovement w-100" @click="$router.push('/power-scan/pick-by-bin')">
                <span><BinMovementIcon/></span>
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-bag" viewBox="0 0 16 16">
                <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
                </svg> -->
                Pick By Bin
            </button>
            </div>
            </div>
            <div class='PsFrontpageButton justify-content-center row'>
            <div class="ButtonWrapper pb-4 col-12">
            <button class="btn btn-secondary Settings w-100" @click="$router.push('/power-scan/settings')">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                </svg>
                Settings
            </button>
            </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BoxReceivingIcon from '../../icons/BoxReceivingIcon'
    import ItemTransfersIcon from '../../icons/ItemTransfersIcon'
    import PickListsIcon from '../../icons/PickListsIcon'
    import BinMovementIcon from '../../icons/BinMovementIcon'
    export default {
        name: 'PowerScan',
        components: {
            BoxReceivingIcon,
            ItemTransfersIcon,
            PickListsIcon,
            BinMovementIcon
        }

    }
</script>
